import { render, staticRenderFns } from "./SgsCenter.vue?vue&type=template&id=0bdc430b&scoped=true"
import script from "./SgsCenter.vue?vue&type=script&lang=js"
export * from "./SgsCenter.vue?vue&type=script&lang=js"
import style0 from "./SgsCenter.vue?vue&type=style&index=0&id=0bdc430b&prod&lang=scss&scoped=true"
import style1 from "./SgsCenter.vue?vue&type=style&index=1&id=0bdc430b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc430b",
  null
  
)

export default component.exports